<template>
  <el-drawer
    title="编辑"
    custom-class="image-edit-panel"
    append-to-body
    direction="rtl"
    :size="400"
    :modal="false"
    :visible.sync="showPanel"
    :before-close="handlePanelClose"
  >
    <div class="container">
      <div class="tab-list">
        <draggable
          v-model="tabList"
          :animation="200"
          :group="'tabList'"
          :disabled="false"
          :ghostClass="'ghost'"
          :handle="'.edit-drag'"
          @start="drag = true"
          @end="drag = false"
          @change="handleSort"
        >
          <div class="tab-item" v-for="(tab, index) in tabs" :key="tab.key" @dblclick="handleEdit(index)">
            <div class="tab-icon">
              <div class="img" v-if="tab.icon">
                <img :src="tab.icon" alt="" />
                <div class="opreate-wrapper" @click.stop="handleDeleteTabIcon(index)">
                  <i class="icon wiki-editable-delete"></i>
                </div>
              </div>
              <upload-image
                v-else
                type="edit"
                :data="tab.icon"
                @onImageUploaded="imageList => handleImageUploaded(imageList, index)"
              >
                <div class="upload-icon">
                  <i class="el-icon el-icon-picture-outline-round"></i>
                </div>
              </upload-image>
            </div>
            <div class="tab-title">
              <input
                v-if="editTabIndex == index"
                type="text"
                :value.sync="tab.title"
                @blur.stop="handleEditTabTitle($event, index)"
                @keydown.enter="handleEditTabTitle($event, index)"
              />
              <span v-else>{{ tab.title }}</span>
            </div>
            <div class="edit-btns">
              <button class="btn edit-drag">
                <i class="icon wiki-editable-drag"></i>
              </button>
              <button class="btn edit-btn" @click.stop="handleEdit(index)">
                <i class="icon wiki-editable-edit"></i>
              </button>
              <button class="btn delete-btn" @click.stop="handleDelete(index)">
                <i class="icon wiki-editable-delete"></i>
              </button>
            </div>
          </div>
        </draggable>
      </div>
      <div class="add-item" @click="handleAddTab">
        <i class="icon iconfont icon-tianjia"></i>
        添加
      </div>
    </div>
  </el-drawer>
</template>

<script>
import draggable from "vuedraggable";
// components
import UploadImage from "../../../components/UploadImage";

export default {
  name: "WikiTabbarEditPanel",
  props: {
    tabs: {
      type: Array,
      default: () => []
    }
  },
  components: {
    draggable,
    UploadImage
  },
  data() {
    return {
      showPanel: false,
      editTabIndex: -1,
      tabList: this.tabs || [],
      drag: false
    };
  },
  watch: {
    tabs(val) {
      this.tabList = val;
    }
  },
  mounted() {},

  methods: {
    open() {
      this.showPanel = true;
    },
    handlePanelClose() {
      this.showPanel = false;
    },
    handleEdit(index) {
      this.editTabIndex = index;
    },
    handleDelete(index) {
      let tabList = JSON.parse(JSON.stringify(this.tabList));
      if (tabList.length == 1) {
        this.$message("最后一项不能删除!");
        return;
      }
      tabList.splice(index, 1);
      this.$emit("onDelete", index);
      this.$emit("onChange", tabList);
    },
    handleEditTabTitle(e, index) {
      if (e.target.value === "") {
        this.$alert("不能设置为空！");
        return;
      }
      this.editTabIndex = -1;
      let tabList = JSON.parse(JSON.stringify(this.tabList));
      tabList[index].title = e.target.value;
      this.$emit("onChange", tabList);
    },
    handleSort() {
      this.$emit("onChange", this.tabList);
    },
    handleImageUploaded(imageList, index) {
      let tabList = JSON.parse(JSON.stringify(this.tabList));
      tabList[index].icon = imageList[0];
      this.$emit("onChange", tabList);
    },
    handleDeleteTabIcon(index) {
      let tabList = JSON.parse(JSON.stringify(this.tabList));
      tabList[index].icon = "";
      this.$emit("onChange", tabList);
    },
    handleAddTab() {
      let tabList = JSON.parse(JSON.stringify(this.tabList));
      tabList.push({
        key: Math.random().toString(16),
        isShowTopDesc: false,
        isShowBottomDesc: false,
        title: "Tab名称",
        icon: "",
        content: []
      });
      this.$emit("onChange", tabList);
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
  .tab-list {
    .tab-item {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      border: 1px solid #e3e3e3;
      padding: 4px 8px;
      margin-bottom: 10px;
      padding-right: 70px;
      .tab-icon {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        box-shadow: 0px 0px 3px 0px rgba(207, 207, 207, 0.29);
        border-radius: 4px;
        border: 1px solid #cacaca;
        margin-right: 12px;
        .img {
          position: relative;
          width: 100%;
          height: 100%;
          &:hover {
            .opreate-wrapper {
              display: flex;
            }
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .opreate-wrapper {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            display: none;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .icon {
              display: inline-block;
              width: 14px;
              height: 14px;
            }
          }
        }
        .upload-icon {
          width: 100%;
          height: 100%;
          font-size: 14px;
          text-align: center;
          line-height: 24px;
          color: #666;
        }
      }

      input {
        border: 1px solid #666;
        height: 24px;
      }
    }
  }
  .add-item {
    width: 100%;
    height: 36px;
    border: 1px dotted #555;
    font-size: 14px;
    color: #555;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    .icon {
      margin-right: 10px;
    }
  }
}

.edit-btns {
  display: inline-flex;
  float: right;
  height: 20px;
  position: absolute;
  right: 6px;
  top: 6px;
  .btn {
    width: 20px;
    height: 20px;
    color: #ffffff;
    border-radius: 4px;
    margin-left: 3px;
    border: none;
    vertical-align: middle;
    line-height: 20px;
    text-align: center;
    &:hover {
      opacity: 0.9;
    }
    .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
